(function () {
  var rootSelector = '[id$="__1783462935adf7f4a8"]';
  var isArabic = (document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0;
  var copy = isArabic ? {
    title: 'الأكثر مبيعًا', eyebrow: 'اختياراتكن المفضلة',
    viewAll: 'مشاهدة كل القطع', next: 'عرض المنتج التالي', previous: 'عرض المنتج السابق',
    badge: 'الأكثر مبيعًا', fallbackType: 'قطعة مميزة', cta: 'اختاري المقاس وأضيفي للسلة',
    exchange: 'توصيل مجاني داخل الكويت للطلبات بقيمة 45 د.ك أو أكثر', shipping: 'شحن دولي متاح', payment: 'دفع إلكتروني آمن فقط',
    deliveryDetails: 'عرض تفاصيل التوصيل', hideDeliveryDetails: 'إخفاء تفاصيل التوصيل', deliveryLabel: 'معلومات التوصيل والدفع',
    product: 'عرض المنتج', colour: 'لون القطعة', size: 'المقاس', unavailable: 'غير متوفر',
    add: 'أضيفي إلى السلة', adding: 'جارٍ الإضافة…', added: 'تمت الإضافة إلى السلة',
    chooseSize: 'اختاري المقاس أولاً', error: 'تعذّرت الإضافة. حاولي مرة أخرى.'
  } : {
    title: 'Best sellers', eyebrow: 'Your favourites',
    viewAll: 'View all pieces', next: 'Show next product', previous: 'Show previous product',
    badge: 'Best seller', fallbackType: 'Featured piece', cta: 'Choose a size and add to cart',
    exchange: 'Free delivery within Kuwait on orders of KD 45 or more', shipping: 'International shipping available', payment: 'Secure online payment only',
    deliveryDetails: 'View delivery details', hideDeliveryDetails: 'Hide delivery details', deliveryLabel: 'Delivery and payment information',
    product: 'View product', colour: 'Product colour', size: 'Size', unavailable: 'Unavailable',
    add: 'Add to cart', adding: 'Adding…', added: 'Added to cart',
    chooseSize: 'Choose a size first', error: 'Could not add this item. Please try again.'
  };
  var productMeta = {
    'maya-blazer': { ar: 'بليزر', en: 'Blazer', colours: [['أسود', '#111111'], ['عاجي', '#e8dfcf']] },
    'cefalu': { ar: 'قطعة علوية', en: 'Top', colours: [['عاجي مخطط', '#ebe4d8']] },
    'espresso-trench': { ar: 'معطف', en: 'Trench coat', colours: [['بني إسبريسو', '#2d211d']] },
    'mocha-set-1': { ar: 'طقم من قطعتين', en: 'Two-piece set', colours: [['موكا', '#928478']] },
    'gardenia-02-gold': { ar: 'طقم ساتان', en: 'Satin set', colours: [['ذهبي', '#b28a4a']] },
    'gardenia-01-black': { ar: 'فستان', en: 'Dress', colours: [['أسود', '#111111']] },
    'gardenia-04': { ar: 'جاكيت', en: 'Jacket', colours: [['بيج', '#c8b49b']] },
    'sol-1': { ar: 'طقم', en: 'Set', colours: [['أصفر', '#e2c45c']] }
  };
  var englishColourNames = {
    'أسود': 'Black', 'عاجي': 'Ivory', 'عاجي مخطط': 'Striped ivory',
    'بني إسبريسو': 'Espresso brown', 'موكا': 'Mocha', 'محايد': 'Neutral',
    'ذهبي': 'Gold', 'بيج': 'Beige', 'أصفر': 'Yellow'
  };

  function escapeHtml(value) {
    return String(value).replace(/[&<>'"]/g, function (character) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character];
    });
  }

  function productHandle(card) {
    try {
      var productUrl = card.dataset.productUrl || card.href || '';
      var parts = new URL(productUrl, window.location.origin).pathname.split('/products/');
      return (parts[1] || '').split('/')[0];
    } catch (error) { return ''; }
  }

  function colourHex(name) {
    var key = String(name).trim().toLowerCase();
    var colours = {
      black:'#111111', white:'#f8f5ef', ivory:'#ebe4d8', cream:'#e8dfcf', beige:'#d7c6ad',
      brown:'#5b3826', mocha:'#928478', espresso:'#2d211d', grey:'#8b8884', gray:'#8b8884',
      navy:'#1f2a44', blue:'#6f9bc5', red:'#a53232', pink:'#d8a6ad', green:'#60745b',
      'أسود':'#111111', 'أبيض':'#f8f5ef', 'عاجي':'#ebe4d8', 'كريمي':'#e8dfcf',
      'بيج':'#d7c6ad', 'بني':'#5b3826', 'موكا':'#928478', 'إسبريسو':'#2d211d', 'رمادي':'#8b8884'
    };
    return colours[key] || '#d8d0c8';
  }

  function renderColours(colours) {
    return '<div class="miramar-products__colors" role="list" aria-label="' + escapeHtml(copy.colour) + '">' + colours.map(function (colour) {
      var label = isArabic ? colour[0] : (englishColourNames[colour[0]] || colour[0]);
      return '<i role="listitem" class="miramar-products__swatch" style="--swatch:' + escapeHtml(colour[1]) + '" title="' + escapeHtml(label) + '" aria-label="' + escapeHtml(label) + '"></i>';
    }).join('') + '</div>';
  }

  function renderSizes(values, availability, variantsBySize) {
    return '<div class="miramar-products__sizes" role="group" aria-label="' + escapeHtml(copy.size) + '">' + values.map(function (value) {
      var available = availability ? availability[value] !== false : true;
      var variant = variantsBySize && variantsBySize[value];
      return '<button type="button" class="miramar-products__size' + (available ? '' : ' is-unavailable') + '"' +
        (available && variant ? ' data-variant-id="' + escapeHtml(variant.id) + '" data-price="' + escapeHtml(variant.price) + '"' : ' disabled aria-disabled="true" title="' + escapeHtml(copy.unavailable) + '"') +
        ' aria-pressed="false">' + escapeHtml(value) + '</button>';
    }).join('') + '</div>';
  }

  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'KWD';
    var locale = isArabic ? 'ar-KW' : 'en-KW';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(Number(cents) / 100);
    } catch (error) {
      return (Number(cents) / 100).toFixed(currency === 'KWD' ? 3 : 2) + ' ' + currency;
    }
  }

  function updateCartCount() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) throw new Error('Cart unavailable');
      return response.json();
    }).then(function (cart) {
      document.querySelectorAll('.miramar-header__cart-link, a.miramar-header__util[href*="/cart"]').forEach(function (link) {
        var count = link.querySelector('.miramar-header__count');
        if (!count && cart.item_count > 0) {
          count = document.createElement('span');
          count.className = 'miramar-header__count';
          link.appendChild(count);
        }
        if (count) {
          count.textContent = cart.item_count;
          count.hidden = cart.item_count < 1;
        }
      });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      return cart;
    });
  }

  function cartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function openCartDrawer(trigger) {
    var drawer = cartDrawer();
    if (!drawer || typeof drawer.open !== 'function') return false;
    drawer.open(trigger || document.activeElement);
    return true;
  }

  function bindCartDrawerLinks() {
    var drawer = cartDrawer();
    if (!drawer) return;

    document.querySelectorAll('.miramar-header__cart-link, a.miramar-header__util[href*="/cart"]').forEach(function (link) {
      if (link.dataset.miramarDrawerBound === 'true') return;
      link.dataset.miramarDrawerBound = 'true';
      link.setAttribute('aria-haspopup', 'dialog');
      link.addEventListener('click', function (event) {
        event.preventDefault();
        openCartDrawer(link);
      });
    });
  }

  function bindPurchaseInteraction(card, options, cta, status) {
    var selectedVariantId = '';
    var selectedPrice = '';

    options.addEventListener('click', function (event) {
      var sizeButton = event.target.closest('.miramar-products__size:not([disabled])');
      if (!sizeButton) return;
      event.preventDefault();
      event.stopPropagation();

      options.querySelectorAll('.miramar-products__size').forEach(function (button) {
        var selected = button === sizeButton;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      selectedVariantId = sizeButton.dataset.variantId || '';
      selectedPrice = sizeButton.dataset.price || '';
      cta.disabled = !selectedVariantId;
      cta.setAttribute('aria-disabled', selectedVariantId ? 'false' : 'true');
      cta.classList.toggle('is-ready', Boolean(selectedVariantId));
      cta.textContent = selectedVariantId ? copy.add + (selectedPrice ? ' — ' + formatMoney(selectedPrice) : '') : copy.cta;
      status.textContent = '';
    });

    cta.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (!selectedVariantId || cta.disabled) {
        status.textContent = copy.chooseSize;
        return;
      }

      cta.disabled = true;
      cta.classList.add('is-loading');
      cta.textContent = copy.adding;
      status.textContent = '';
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      var drawer = cartDrawer();
      var formData = new FormData();
      formData.append('id', selectedVariantId);
      formData.append('quantity', '1');
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        formData.append('sections', drawer.getSectionsToRender().map(function (section) { return section.id; }).join(','));
        formData.append('sections_url', window.location.pathname);
        if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(cta);
      }

      fetch(root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
        body: formData
      }).then(function (response) {
        if (!response.ok) return response.json().then(function (data) { throw new Error(data.description || copy.error); });
        return response.json();
      }).then(function (response) {
        if (drawer && response.sections && typeof drawer.renderContents === 'function') {
          drawer.classList.remove('is-empty');
          drawer.renderContents(response);
        }
        return updateCartCount();
      }).then(function () {
        cta.classList.remove('is-loading');
        cta.classList.add('is-added');
        cta.textContent = copy.added;
        status.textContent = copy.added;
        window.setTimeout(function () {
          cta.disabled = false;
          cta.classList.remove('is-added');
          cta.textContent = copy.add + (selectedPrice ? ' — ' + formatMoney(selectedPrice) : '');
        }, 1800);
      }).catch(function (error) {
        cta.disabled = false;
        cta.classList.remove('is-loading');
        cta.textContent = copy.add + (selectedPrice ? ' — ' + formatMoney(selectedPrice) : '');
        status.textContent = error && error.message ? error.message : copy.error;
      });
    });

    card.addEventListener('click', function (event) {
      if (event.target.closest('.miramar-products__options, .miramar-products__cta')) {
        event.preventDefault();
        return;
      }
      if (event.target.closest('a, button')) return;
      var productUrl = card.dataset.productUrl;
      if (productUrl) window.location.assign(productUrl);
    });
  }

  bindCartDrawerLinks();

  function hydrateProduct(card, options, meta) {
    var url = new URL(card.dataset.productUrl || card.href, window.location.origin);
    url.pathname = url.pathname.replace(/\/$/, '') + '.js';
    fetch(url.toString(), { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) throw new Error('Product data unavailable');
      return response.json();
    }).then(function (product) {
      var sizeOption = product.options.find(function (option) { return /^(size|taille|المقاس)$/i.test(option.name); });
      var colourOption = product.options.find(function (option) { return /^(color|colour|couleur|اللون)$/i.test(option.name); });
      var sizeValues = sizeOption ? sizeOption.values : [];
      var sizeAvailability = {};
      var variantsBySize = {};
      if (sizeOption) {
        product.variants.forEach(function (variant) {
          var value = variant['option' + sizeOption.position];
          sizeAvailability[value] = Boolean(sizeAvailability[value] || variant.available);
          if (variant.available && !variantsBySize[value]) variantsBySize[value] = variant;
        });
      }
      var colours = colourOption ? colourOption.values.map(function (value) { return [value, colourHex(value)]; }) : meta.colours;
      options.innerHTML = renderColours(colours) + renderSizes(sizeValues, sizeAvailability, variantsBySize);
      options.setAttribute('aria-busy', 'false');
      var cta = card.querySelector('.miramar-products__cta');
      var status = card.querySelector('.miramar-products__status');
      if (cta && status) bindPurchaseInteraction(card, options, cta, status);
    }).catch(function () {
      options.innerHTML = renderColours(meta.colours);
      options.setAttribute('aria-busy', 'false');
      var cta = card.querySelector('.miramar-products__cta');
      var status = card.querySelector('.miramar-products__status');
      if (cta) {
        cta.disabled = true;
        cta.setAttribute('aria-disabled', 'true');
      }
      if (status) status.textContent = copy.error;
    });
  }

  function enhanceProducts() {
    var root = document.querySelector(rootSelector);
    if (!root || root.dataset.miramarEnhanced === 'true') return;

    var title = root.querySelector('[class*="ai-bestsellers-title"]');
    var header = root.querySelector('[class*="ai-bestsellers-header"]');
    var grid = root.querySelector('[class*="ai-bestsellers-grid"]');
    var section = grid && grid.parentElement && grid.parentElement.parentElement;
    if (!title || !header || !grid || !section) return;

    var editableSubtitle = root.querySelector('[class*="ai-bestsellers-subtitle"]');
    var editableBadge = root.querySelector('[class*="ai-bestsellers-badge"]');
    var editableBrowse = root.querySelector('[class*="ai-bestsellers-cta-wrapper"] a');
    var editableRoot = root.querySelector('[data-title-en]') || root;
    var localeSuffix = isArabic ? 'Ar' : 'En';
    copy.title = editableRoot.dataset['title' + localeSuffix] || title.textContent.trim() || copy.title;
    copy.eyebrow = editableRoot.dataset['eyebrow' + localeSuffix] || (editableSubtitle && editableSubtitle.textContent.trim()) || copy.eyebrow;
    copy.badge = (isArabic ? (editableBadge && editableBadge.textContent.trim()) : editableRoot.dataset.badgeEn) || copy.badge;
    copy.viewAll = (isArabic ? (editableBrowse && editableBrowse.textContent.trim()) : editableRoot.dataset.viewAllEn) || copy.viewAll;
    title.textContent = copy.title;

    root.querySelectorAll('.miramar-products__eyebrow, .miramar-products__browse, .miramar-products__shipping').forEach(function (item) {
      item.remove();
    });
    root.querySelectorAll('.miramar-products__heart, .miramar-products__badge, .miramar-products__type, .miramar-products__options, .miramar-products__cta').forEach(function (item) {
      item.remove();
    });

    header.insertAdjacentHTML('afterbegin', '<div class="miramar-products__eyebrow"><span aria-hidden="true">✦</span><span class="miramar-products__eyebrow-label">' + escapeHtml(copy.eyebrow) + '</span></div>');
    var assetRoot = root.querySelector('[data-arrow-left-src]') || root;
    var arrowLeftSrc = assetRoot.dataset.arrowLeftSrc || '';
    var arrowRightSrc = assetRoot.dataset.arrowRightSrc || '';
    var arrowLeft = arrowLeftSrc ? '<img src="' + escapeHtml(arrowLeftSrc) + '" alt="" width="21" height="21" aria-hidden="true" draggable="false">' : '';
    var arrowRight = arrowRightSrc ? '<img src="' + escapeHtml(arrowRightSrc) + '" alt="" width="21" height="21" aria-hidden="true" draggable="false">' : '';
    header.insertAdjacentHTML('beforeend', '<div class="miramar-products__browse"><a class="miramar-products__view" href="' + (isArabic ? '/ar/collections/all' : '/collections/all') + '">' + escapeHtml(copy.viewAll) + '</a><div class="miramar-products__controls" dir="ltr"><button type="button" class="miramar-products__arrow miramar-products__arrow--left" aria-label="' + escapeHtml(copy.next) + '">' + arrowLeft + '</button><button type="button" class="miramar-products__arrow miramar-products__arrow--right" aria-label="' + escapeHtml(copy.previous) + '">' + arrowRight + '</button></div></div>');
    var cards = Array.prototype.slice.call(grid.children).filter(function (card) {
      return Boolean(card.dataset.productUrl || (card.href && card.href.indexOf('/products/') > -1));
    });

    cards.forEach(function (card, index) {
      var titleElement = card.querySelector('[class*="ai-bestsellers-product-title"]');
      var image = card.querySelector('[class*="ai-bestsellers-image-wrapper"]');
      var info = card.querySelector('[class*="ai-bestsellers-info"]');
      var handle = productHandle(card);
      var meta = productMeta[handle] || { ar: copy.fallbackType, en: copy.fallbackType, colours: [['محايد', '#d8d0c8']] };

      card.classList.add('miramar-products__card');
      if (image) {
        image.insertAdjacentHTML('beforeend', '<span class="miramar-products__badge">' + escapeHtml(copy.badge) + '</span>');
      }
      if (titleElement) {
        titleElement.insertAdjacentHTML('afterend', '<small class="miramar-products__type">' + escapeHtml(isArabic ? meta.ar : meta.en) + '</small>');
      }
      if (info) {
        info.insertAdjacentHTML('afterend', '<div class="miramar-products__options" aria-busy="true">' + renderColours(meta.colours) + '</div><button type="button" class="miramar-products__cta" disabled aria-disabled="true">' + escapeHtml(copy.cta) + '</button><span class="miramar-products__status" role="status" aria-live="polite"></span>');
        hydrateProduct(card, info.nextElementSibling, meta);
      }
    });

    section.insertAdjacentHTML('beforeend',
      '<div class="miramar-products__shipping" aria-label="' + escapeHtml(copy.deliveryLabel) + '">' +
        '<div class="miramar-products__shipping-desktop">' +
          '<span aria-hidden="true">✦</span><b>' + escapeHtml(copy.exchange) + '</b>' +
          '<span aria-hidden="true">✦</span><b>' + escapeHtml(copy.shipping) + '</b>' +
          '<span aria-hidden="true">✦</span><b>' + escapeHtml(copy.payment) + '</b>' +
        '</div>' +
        '<details class="miramar-products__shipping-disclosure">' +
          '<summary>' +
            '<span class="miramar-products__shipping-primary"><span aria-hidden="true">✦</span><b>' + escapeHtml(copy.exchange) + '</b></span>' +
            '<span class="miramar-products__shipping-toggle">' +
              '<span class="miramar-products__shipping-more">' + escapeHtml(copy.deliveryDetails) + '</span>' +
              '<span class="miramar-products__shipping-less">' + escapeHtml(copy.hideDeliveryDetails) + '</span>' +
              '<svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true" focusable="false"><path d="m5 7.5 5 5 5-5" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
            '</span>' +
          '</summary>' +
          '<div class="miramar-products__shipping-panel">' +
            '<p><span aria-hidden="true">✦</span><span>' + escapeHtml(copy.shipping) + '</span></p>' +
            '<p><span aria-hidden="true">✦</span><span>' + escapeHtml(copy.payment) + '</span></p>' +
          '</div>' +
        '</details>' +
      '</div>');

    function rotateDesktop(step) {
      if (!grid.firstElementChild || !grid.lastElementChild) return;
      if (step > 0) {
        grid.appendChild(grid.firstElementChild);
      } else {
        grid.insertBefore(grid.lastElementChild, grid.firstElementChild);
      }
    }

    function moveMobile(step) {
      var cardWidth = cards[0].getBoundingClientRect().width;
      var gap = parseFloat(window.getComputedStyle(grid).columnGap || window.getComputedStyle(grid).gap) || 0;
      grid.scrollBy({ left: step * -(cardWidth + gap), behavior: 'smooth' });
    }

    var leftButton = root.querySelector('.miramar-products__arrow--left');
    var rightButton = root.querySelector('.miramar-products__arrow--right');
    if (leftButton) leftButton.addEventListener('click', function () {
      window.matchMedia('(max-width: 749px)').matches ? moveMobile(1) : rotateDesktop(1);
    });
    if (rightButton) rightButton.addEventListener('click', function () {
      window.matchMedia('(max-width: 749px)').matches ? moveMobile(-1) : rotateDesktop(-1);
    });

    root.dataset.miramarEnhanced = 'true';
  }

  function boot() {
    enhanceProducts();
    bindCartDrawerLinks();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        updateCartCount().catch(function () {});
      });
    }

    new MutationObserver(function () {
      var root = document.querySelector(rootSelector);
      if (root && root.dataset.miramarEnhanced !== 'true') enhanceProducts();
    }).observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', function () {
      var root = document.querySelector(rootSelector);
      if (root) root.dataset.miramarEnhanced = 'false';
      enhanceProducts();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
